/**
 * Generates a random 8-character alphanumeric code (0-9, A-Z) for academy_id_join / community_id_join.
 * Used to identify and join an academy or community via a short shareable code.
 */
const ALPHANUM = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function generateJoinCode() {
  const length = 8;
  let code = '';
  const bytes = new Uint8Array(length);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  for (let i = 0; i < length; i++) {
    code += ALPHANUM[bytes[i] % ALPHANUM.length];
  }
  return code;
}
